import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Tag, ArrowLeft } from "lucide-react";
import { useApp } from "../context/AppContext";
import { resolveImg } from "../lib/api";
import { useBooking } from "../lib/bookingStore";
import { Button } from "./ui/button";

export default function OfferCard({ offer, index = 0 }) {
  const { t, L } = useApp();
  const nav = useNavigate();
  const { setOffer } = useBooking();
  const discount = offer.old_price > 0
    ? Math.round(((offer.old_price - offer.new_price) / offer.old_price) * 100)
    : 0;

  const book = () => {
    setOffer(offer);
    nav("/book");
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      className="group rounded-3xl overflow-hidden bg-card cb-card-shadow flex flex-col"
      data-testid={`offer-card-${offer.id}`}
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={resolveImg(offer.image_url)}
          alt={L(offer, "title")}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {discount > 0 && (
          <span className="absolute top-4 start-4 inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-destructive text-destructive-foreground text-sm font-bold">
            <Tag className="h-4 w-4" /> -{discount}%
          </span>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="text-xl font-semibold text-foreground">{L(offer, "title")}</h3>
        <p className="text-sm text-muted-foreground mt-2 flex-1">{L(offer, "desc")}</p>
        <div className="flex items-end gap-3 mt-4">
          <span className="text-2xl font-bold text-primary">{offer.new_price} {t.common.sar}</span>
          {offer.old_price > 0 && (
            <span className="text-base text-muted-foreground line-through mb-0.5">{offer.old_price}</span>
          )}
        </div>
        {offer.expiry_date && (
          <p className="text-xs text-muted-foreground mt-2">{t.offers.expires}: {offer.expiry_date}</p>
        )}
        <Button onClick={book} className="mt-4 rounded-full font-semibold group" data-testid={`offer-book-btn-${offer.id}`}>
          {t.offers.bookOffer}
          <ArrowLeft className="h-4 w-4 ms-2 rtl-flip transition-transform group-hover:-translate-x-1" />
        </Button>
      </div>
    </motion.div>
  );
}
